module.exports = __webpack_public_path__ + "img/QR-1999.1b4555cb.png";